import { render } from "./UpMedicalProvider.vue?vue&type=template&id=7626fdaa&scoped=true"
import script from "./UpMedicalProvider.vue?vue&type=script&lang=js"
export * from "./UpMedicalProvider.vue?vue&type=script&lang=js"

import "./UpMedicalProvider.vue?vue&type=style&index=0&id=7626fdaa&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7626fdaa"]])

export default __exports__